import React, { useEffect, useState } from 'react';
import { SView, SInput, SText, STheme, SPage } from 'servisofts-component';
import { TouchableOpacity } from 'react-native-gesture-handler';
import SSocket from 'servisofts-socket';

const InfoInversion = (props) => {
    const [textareaValue, setTextareaValue] = useState("");
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        SSocket.sendPromise({
            component: "enviroments",
            type: "get",
            key: "informacion_inversion",
        }).then((resp) => {
            if (!resp) return;
            if (resp.data) {
                setTextareaValue(resp.data);
            }
        }).catch((e) => {
            console.log("Error al obtener la informacion de inversion", e);
        });

    }, []);

const enviarInformacion = async () => {
    setLoading(true); 
    try {
        await SSocket.sendPromise({
            component: "enviroments",
            type: "editar",
            data: {
                key: "informacion_inversion",
                data: textareaValue
            }
        });

       
        await new Promise(resolve => setTimeout(resolve, 1000));

        // SNotification.send({ title: "Guardado correctamente" });
    } catch (e) {
        console.log("Error al guardar", e);
        // SNotification.send({ title: "Error al guardar", body: e.message, color: STheme.color.danger });
    } finally {
        setLoading(false); 
    }
}

    return (
        <SPage title={"Info Inversion"} center>
            <SView col={"xs-6"} flex center style={{ height: "100vh" }}>
                <SView
                    col={"xs-12"}
                    center
                    style={{
                        alignContent: "center",
                        justifyContent: "center",
                        padding: 10,
                        maxWidth: 470,
                    }}
                >
                    <SText fontSize={20} color={STheme.color.text} center>
                        Ingresar informacion de inversiones
                    </SText>
                    <SInput
                        placeholder="Ingrese detalles"
                        value={textareaValue}
                        onChangeText={setTextareaValue}
                        style={{ marginVertical: 16, width: 450, height: 400 }}
                        multiline
                    />
                </SView>

                <TouchableOpacity
                    disabled={loading} 
                    style={{
                        width: 150,
                        height: 50,
                        marginTop: 16,
                        backgroundColor: loading ? STheme.color.warning : STheme.color.danger,
                        borderRadius: 8,
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onPress={enviarInformacion}
                >
                    <SText color={STheme.color.white} fontSize={18}>
                        {loading ? "Guardando..." : "Guardar"}
                    </SText>
                </TouchableOpacity>
            </SView>
        </SPage>
    );
};

export default InfoInversion;